import Footer from "components/Frontend/Footer";
import Header from "components/Frontend/Header";
import React from "react";
import { Helmet } from "react-helmet";
import { EFFECTIVE_DATE } from "constants/policyDate";
import HeroSectionUpdatedSecond from "components/PublicPagesReusable/HeroSectionUpdatedSecond";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import NocBanner from "components/PublicPagesReusable/NocBanner";

const PrivacyPolicy = () => {

  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text">  
          <span className="text-success">Privacy </span>Policy
      </h1>
    );
  };

  const heroData = {
    badge: "Australia’s Leading English Proficiency Centre",
    title: heroWorkTitle,
    subtitle: `Language Academy Australia Pty Ltd <br/> Effective Date: ${EFFECTIVE_DATE}`,
    
    users: [
      
    ],
    trustText: "",
    
    bottomStatsText: [
      { value: "8",highlight:'+', label: "Years of NAATI Expertise" },
      { value: "50k", highlight:'+', label: "Students' Helped" },
      { value: "10", highlight:'+', label: "Global Locations" },
      { value: "95", highlight:'%', label: "Success Rate" }
    ]
  };
  return (
    <>
      <Helmet>
        <title>Privacy Policy | LA Language Academy Australia</title>
        <meta name="description" content="Read our privacy policy, learn how we collect, use, and protect your personal information. Your privacy matters to us every step of the way." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/privacy-policy`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="Privacy Policy | LA Language Academy Australia" />
        <meta name="twitter:description" content="Read our privacy policy, learn how we collect, use, and protect your personal information. Your privacy matters to us every step of the way." />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/privacy-policy`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Privacy Policy | LA Language Academy Australia" />
        <meta property="og:description" content="Read our privacy policy, learn how we collect, use, and protect your personal information. Your privacy matters to us every step of the way." />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
      <Header />
           {/* <HeroSectionUpdatedSecond data={heroData} />   */}
             <NocBanner
          data={heroData}
          extraClass={"contact-hero-section pte-scoring"}
          extraClass2={"align-items-start"}
        />
           <div className="w-100 off-white pt-5">           
            <div style={{width:"94%" , marginInline:"auto" , fontFamily: "'Plus Jakarta Sans', sans-serif" }} className="custom-container py-5 ">
                        
                        <div className="py-4 refund-policy-border">
                         <h4 className="fw-600">Introduction</h4>
                         <p className="FS16FW500">This Privacy Policy explains how Language Academy Australia Pty Ltd ("Language Academy," "we," "us," or "our") collects, uses, stores, and shares your personal information when you access or use our website (languageacademy.com.au), mobile applications, and associated services (collectively, the "Platform").</p>
           
                         <p className="FS16FW500">
By accessing or using the Platform, you agree to the collection and use of your information as described in this Privacy Policy. If you do not agree, please discontinue use of the Platform.</p>

          <p className="FS16FW500">We are committed to protecting your privacy in accordance with the Australian Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs).</p>
                        </div>

                        <div className="py-4 refund-policy-border">
                         <h4 className="fw-600">Information We Collect</h4>
                         <p className="FS16FW500 fst-italic fw-700">We collect personal information in the following ways:</p>
                         
                         <ul className="list-disc ps-4 FS16FW500 mt-4">
                           <li className="mb-4">
                             <span className="fw-bold FS20FW500">Information You Provide Directly</span>
                             <p className="mt-2 mb-2 FS16FW500">When you register an account, enrol in a course, or contact us, we may collect:</p>
                             <ul className="list-disc ps-4 mt-2">
                               <li className="mb-2">Full name</li>
                               <li className="mb-2">Email address</li>
                               <li className="mb-2">Phone number</li>
                               <li className="mb-2">Profile picture</li>
                               <li className="mb-2">Payment information (processed securely via third-party payment providers — we do not store full card details)</li>
                               <li className="mb-2">Any feedback, reviews, or messages you submit through the Platform</li>
                             </ul>
                           </li>
                           
                           <li className="mb-4">
                             <span className="fw-bold FS20FW500">Information Collected Automatically</span>
                             <p className="mt-2 mb-2 FS16FW500">When you use the Platform, we automatically collect certain technical and usage data, including:</p>
                             <ul className="list-disc ps-4 mt-2">
                               <li className="mb-2">IP address and approximate location</li>
                               <li className="mb-2">Browser type and version</li>
                               <li className="mb-2">Device type and operating system</li>
                               <li className="mb-2">Pages visited, time spent, and navigation patterns</li>
                               <li className="mb-2">Referring URLs (the page you visited before arriving at our Platform)</li>
                             </ul>
                             <p className="mt-3 FS16FW500">This information is aggregated and used for internal research to understand user demographics, interests, and behaviour. It is not used to personally identify you unless combined with other data you have provided.</p>
                           </li>
                           
                           <li className="mb-4">
                             <span className="fw-bold FS20FW500">Information from Third Parties</span>
                             <p className="mt-2 FS16FW500">If you log in or register via a third-party service (e.g. Google), we may receive basic profile information from that provider in accordance with your settings and their privacy policy.</p>
                           </li>
                         </ul>
                        </div>

                        <div className="py-4 refund-policy-border">
                          <h4 className="fw-600">How We Use Your Information</h4>
                          <p className="FS16FW500">We use the personal information we collect to:</p>
                          
                          <ul className="list-disc ps-4 FS16FW500 mt-4">
                            <li className="mb-2">Create and manage your account</li>
                            <li className="mb-2">Process enrolments and payments</li>
                            <li className="mb-2">Deliver course content, materials, and support</li>
                            <li className="mb-2">Send you important service-related communications (enrolment confirmations, schedule updates, billing notices)</li>
                            <li className="mb-2">Send you promotional emails and offers based on your interests — you may opt out at any time (see Section 7)</li>
                            <li className="mb-2">Improve and personalise your experience on the Platform</li>
                            <li className="mb-2">Conduct internal analytics and research to enhance our services</li>
                            <li className="mb-2">Comply with our legal obligations and resolve disputes</li>
                          </ul>
                          
                          <p className="FS16FW500 mt-4">We will not use your personal information for any purpose that is incompatible with the purpose for which it was collected without your consent.</p>
                         </div>

                         <div className="py-4 refund-policy-border">
                          <h4 className="fw-600">How We Share Your Information</h4>
                          <p className="FS16FW500">We do not sell your personal information to third parties. We may share your information in the following limited circumstances:</p>
                          
                          <ul className="list-disc ps-4 FS16FW500 mt-4">
                            <li className="mb-4">
                              <span className="fw-bold FS20FW500">Service Providers</span>
                              <p className="mt-2 FS16FW500">We engage trusted third-party service providers to assist us in operating the Platform, processing payments, sending communications, and analysing usage. These providers are contractually required to handle your data securely and only for the purposes we specify.</p>
                            </li>
                            <li className="mb-4">
                              <span className="fw-bold FS20FW500">Legal Requirements</span>
                              <p className="mt-2 FS16FW500">We may disclose your personal information where required by law, regulation, or court order, or where we believe disclosure is necessary to protect the rights, property, or safety of Language Academy, our users, or the public.</p>
                            </li>
                            <li className="mb-4">
                              <span className="fw-bold FS20FW500">Business Transfers</span>
                              <p className="mt-2 FS16FW500">In the event of a merger, acquisition, or sale of all or part of our business, your personal information may be transferred to the acquiring entity as part of that transaction. We will notify you via email or a prominent notice on the Platform before your data is transferred and becomes subject to a different privacy policy.</p>
                            </li>
                            <li className="mb-4">
                              <span className="fw-bold FS20FW500">With Your Consent</span>
                              <p className="mt-2 FS16FW500">We may share your information with third parties where you have given us explicit consent to do so.</p>
                            </li>
                          </ul>
                         </div>

                         <div className="py-4 refund-policy-border">
                           <h4 className="fw-600">Mobile App and iOS-Specific Disclosures</h4>
                           <p className="FS16FW500">The following disclosures apply specifically to our mobile applications:</p>
                           
                           <ul className="list-disc ps-4 FS16FW500 mt-4">
                             <li className="mb-2">We do not track users across third-party apps or websites for advertising purposes on iOS</li>
                             <li className="mb-2">We do not use the Apple Advertising Identifier (IDFA) for advertising or tracking purposes unless explicit user permission is obtained as required by law</li>
                             <li className="mb-2">Any analytics or diagnostics data collected through the app is used solely to improve app performance and user experience</li>
                             <li className="mb-2">We do not share app usage data with third-party advertisers</li>
                           </ul>
                         </div>

                         <div className="py-4 refund-policy-border">
                           <h4 className="fw-600">Data Storage and Security</h4>
                           <p className="FS16FW500">All personal data you provide is securely stored on encrypted servers. We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, loss, misuse, alteration, or destruction.</p>
                           
                           <p className="FS16FW500 mt-4">However, no method of data transmission over the internet or electronic storage is completely secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee absolute security. Transmission of information is done at your own risk.</p>
                           
                           <p className="FS16FW500 mt-4">We strongly recommend that you:</p>
                           
                           <ul className="list-disc ps-4 FS16FW500 mt-4">
                             <li className="mb-2">Choose a strong, unique password for your account</li>
                             <li className="mb-2">Keep your password confidential and do not share it with others</li>
                             <li className="mb-2">Log out of your account and close your browser when using shared or public devices</li>
                           </ul>
                         </div>

                         <div className="py-4 refund-policy-border">
                           <h4 className="fw-600">Your Rights and Choices</h4>
                           
                           <ul className="list-disc ps-4 FS16FW500 mt-4">
                             <li className="mb-4">
                               <span className="fw-bold FS20FW500">Access and Correction</span>
                               <p className="mt-2 FS16FW500">You have the right to request access to the personal information we hold about you and to request corrections if it is inaccurate, incomplete, or out of date. To make a request, contact us at <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a>.</p>
                             </li>
                             
                             <li className="mb-4">
                               <span className="fw-bold FS20FW500">Marketing Opt-Out</span>
                               <p className="mt-2 FS16FW500">You may unsubscribe from our marketing emails at any time by clicking the unsubscribe link in any marketing email, or by contacting us at <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a>. Note that even if you unsubscribe from marketing communications, we may still send you essential transactional or administrative emails (e.g. enrolment confirmations, billing notices).</p>
                             </li>
                             
                             <li className="mb-4">
                               <span className="fw-bold FS20FW500">Account Deletion</span>
                               <p className="mt-2 FS16FW500">You may request deletion of your account and all associated personal data at any time by contacting us at <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a>. We will process your request within a reasonable timeframe, subject to any legal obligations that require us to retain certain data.</p>
                             </li>
                           </ul>
                         </div>

                         <div className="py-4 refund-policy-border">
                           <h4 className="fw-600">Cookies and Tracking Technologies</h4>
                           <p className="FS16FW500">Our website uses cookies and similar tracking technologies to enhance your experience, remember your preferences, and analyse site traffic. Cookies are small text files stored on your device.</p>
                           
                           <p className="FS16FW500 mt-4">You can control cookie settings through your browser preferences. Please note that disabling certain cookies may affect the functionality of the Platform. By continuing to use the Platform, you consent to our use of cookies as described in this policy.</p>
                         </div>

                          <div className="py-4 refund-policy-border">
                           <h4 className="fw-600">Data Retention</h4>
                           <p className="FS16FW500">We retain your personal information for as long as your account is active or as needed to provide you with our services. We may also retain certain information as required by law, for dispute resolution, or to enforce our agreements. When your data is no longer required, we will securely delete or anonymise it.</p>
                         </div>

                         <div className="py-4 refund-policy-border">
                           <h4 className="fw-600">Third-Party Links</h4>
                           <p className="FS16FW500">The Platform may contain links to third-party websites or services. We are not responsible for the privacy practices of those third parties. We encourage you to review the privacy policies of any third-party sites you visit.</p>
                         </div>

                         <div className="py-4 refund-policy-border">
                           <h4 className="fw-600">Changes to this Privacy Policy</h4>
                           <p className="FS16FW500">We reserve the right to update this Privacy Policy at any time. When we do, we will revise the effective date at the top of this page. We will endeavour to notify you of significant changes, but your continued use of the Platform following any changes constitutes your acceptance of the updated policy. We recommend checking this page periodically.</p>
                         </div>

                         <div className="py-4">
               <h4 className="fw-600">Contact Us</h4>
               <p style={{color:"#686868"}} className="FS16FW500">For any questions about this Privacy Policy, please contact us:</p>

               <div className="d-flex flex-wrap mt-4" style={{ gap: "20px 40px" }}>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Inquiry</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">
                     <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a>
                   </p>
                 </div>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Call Us</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">
                     <a href="tel:+61426230061" className="text-dark text-decoration-none">+61 426 230 061</a>
                   </p>
                 </div>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Visit Us</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">46 George Street, Parramatta NSW 2150</p>
                 </div>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Website</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">
                     <a href="https://www.languageacademy.com.au" target="_blank" rel="noopener noreferrer" className="text-dark text-decoration-underline">https://www.languageacademy.com.au</a>
                   </p>
                 </div>
               </div>
               <p className="text-secondary FS16FW500 mb-1">If you are not satisfied with our response, you may lodge a complaint with the Office of the Australian Information Commissioner (OAIC) at www.oaic.gov.au.</p>
              </div>  
             </div>   
           </div>
                       <div className="custom-container mt-2" style={{ padding: "40px 0 30px 0" ,width:"94%" }}>
                           <CtaBanner
                             title="Ready to Test Your "
                             highlight="Level?"
                             buttonText="Book Free Consultation"
                             onClick={() => { const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop')); modal.show(); }}
                             rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
                             btnText="Take Free Mock Test"
                             subTitle={"Take a free mock test and understand your current standing before enrolling."}
                           />
                         </div>
      <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;
